import { useEffect, useState } from 'react';
import { api } from '../api';

const emptyForm = { vv_name: '', vv_content: '', is_visible: true, details: [{ detail_key: '', detail_value: '' }] };

export default function VisionPage() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editId, setEditId] = useState(null);

  const load = () => api.visions.list().then(setItems).catch((error) => alert(error.message));
  useEffect(() => { load(); }, []);

  const submit = (event) => {
    event.preventDefault();
    api.visions.save(editId, form)
      .then(() => { setForm(emptyForm); setEditId(null); load(); })
      .catch((error) => alert(error.response?.data?.message || error.message));
  };

  return (
    <>
      <h2>비전</h2>
      <form onSubmit={submit}>
        <input placeholder="이름" value={form.vv_name} onChange={(e) => setForm({ ...form, vv_name: e.target.value })} required />
        <textarea placeholder="설명" value={form.vv_content || ''} onChange={(e) => setForm({ ...form, vv_content: e.target.value })} />
        <label><input type="checkbox" checked={!!form.is_visible} onChange={(e) => setForm({ ...form, is_visible: e.target.checked })} /> 소개 페이지 노출</label>
        {(form.details || []).map((detail, index) => (
          <div className="row" key={index}>
            <input placeholder="key" value={detail.detail_key} onChange={(e) => {
              const details = [...form.details];
              details[index] = { ...detail, detail_key: e.target.value };
              setForm({ ...form, details });
            }} />
            <input placeholder="value" value={detail.detail_value} onChange={(e) => {
              const details = [...form.details];
              details[index] = { ...detail, detail_value: e.target.value };
              setForm({ ...form, details });
            }} />
          </div>
        ))}
        <button type="button" className="ghost" onClick={() => setForm({ ...form, details: [...form.details, { detail_key: '', detail_value: '' }] })}>세부 추가</button>
        <div className="row">
          <button type="submit">{editId ? '수정' : '추가'}</button>
          <button type="button" className="ghost" onClick={() => { setForm(emptyForm); setEditId(null); }}>취소</button>
        </div>
      </form>
      {items.map((item) => (
        <div className="card" key={item.vv_id}>
          <strong>{item.vv_name}</strong> {item.is_visible ? '' : '(숨김)'}
          <p>{item.vv_content}</p>
          <p>{(item.details || []).map((detail) => detail.detail_value).join(', ')}</p>
          <div className="row">
            <button type="button" onClick={() => { setEditId(item.vv_id); setForm({ ...item, details: item.details?.length ? item.details : emptyForm.details }); }}>수정</button>
            <button type="button" className="danger" onClick={() => window.confirm('삭제할까요?') && api.visions.remove(item.vv_id).then(load)}>삭제</button>
          </div>
        </div>
      ))}
    </>
  );
}
